import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getGeneralIncomeTypes,
  clearGeneralIncomeTypes,
} from '../../../../actions/index';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';
import { DEFAULT_SELECT_PLACEHOLDER } from '../../../../config/constants';

class GeneralIncomeTypeSelect extends Component {
  componentDidMount() {
    this.props.dispatchGetGeneralIncomeTypes(DEFAULT_QUERY_GET_ALL);
  }

  componentWillUnmount() {
    const { dispatchClearGeneralIncomeTypes } = this.props;
    dispatchClearGeneralIncomeTypes();
  }

  render() {
    const {
      loading,
      options,
      isGridVariant,
      value,
      isMulti,
      isClearable,
      onValueChange,
      placeholder,
      ...rest
    } = this.props;
    return (
      <Select
        isLoading={loading}
        options={options}
        isMulti={isMulti}
        input={{ value }}
        onValueChange={onValueChange}
        isClearable={isClearable}
        isGridVariant={isGridVariant}
        placeholder={placeholder}
        {...rest}
      />
    );
  }
}

GeneralIncomeTypeSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  options: optionsPropTypes.isRequired,
  loading: PropTypes.bool.isRequired,
  noOptionsMessage: PropTypes.func,
  dispatchGetGeneralIncomeTypes: PropTypes.func.isRequired,
  dispatchClearGeneralIncomeTypes: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  onValueChange: PropTypes.func,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
};

GeneralIncomeTypeSelect.defaultProps = {
  noOptionsMessage: undefined,
  isDisabled: false,
  isGridVariant: false,
  onValueChange: undefined,
  isClearable: false,
  value: {},
  isMulti: false,
  placeholder: DEFAULT_SELECT_PLACEHOLDER,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  options: AccountingUnit.GeneralIncomeType.getIn([
    'all',
    'content',
    'content',
  ]).map((voucherType) => ({
    value: voucherType.id,
    label: voucherType.name,
  })),
  loading: AccountingUnit.GeneralIncomeType.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetGeneralIncomeTypes: getGeneralIncomeTypes,
  dispatchClearGeneralIncomeTypes: clearGeneralIncomeTypes,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GeneralIncomeTypeSelect);
